import { render, staticRenderFns } from "./InterfaceManage.vue?vue&type=template&id=0754bf00&scoped=true"
import script from "./InterfaceManage.vue?vue&type=script&lang=js"
export * from "./InterfaceManage.vue?vue&type=script&lang=js"
import style0 from "./InterfaceManage.vue?vue&type=style&index=0&id=0754bf00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___2141a494b913d03a9170cbed536032b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754bf00",
  null
  
)

export default component.exports